export const Bio = {
  name: "Suraj Chowdhury",
  roles: [
    "Senior Product Software Engineer",
    "Full Stack Developer",
    "Software Development Engineer in Test",
  ],
  description:
    "I am a motivated and versatile individual with a passion for learning and an unwavering commitment to delivering high-quality results. My growth mindset and adaptability empower me to tackle new challenges with confidence and enthusiasm.",
  github: "https://github.com/Surajchowdhury12",
  resume:
    "https://drive.google.com/file/d/1WRqk8uCDhNKWioLsrg5fJr2jGlZ6jhyE/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/suraj-chowdhury/",
  twitter: "https://x.com/SURAJCh122",
  instagram: "https://www.instagram.com/isurajchowdhury/",
};


export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Grafana",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      },
      {
        name: "Azure DevOps",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975985/download_11_hvqkcs.png",
      },
      {
        name: "Bamboo",
        image:
          "https://framerusercontent.com/images/gGLnqjE5xWSUGmAeN5KFL1NRCug.png",
      },
    ],
  },
  {
    title: "Automation",
    skills: [
      {
        name: "Playwright",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734974965/download_3_njfyqq.png",
      },
      {
        name: "Cypress",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975061/download_1_rrh11a.jpg",
      },
      {
        name: "Selenium",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975166/1_musVE9e4bgjTWeoRmc-P_w_ytz9lt.png",
      },
      {
        name: "Postman",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975336/download_4_gcdx0s.png",
      },
      {
        name: "Appium",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975460/download_5_q5vwnt.png",
      },
      {
        name: "Rest Assured",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975535/download_6_ahzgo5.png",
      },
    ],
  },
  {
    title: "Frameworks",
    skills: [
      {
        name: "Cucumber",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975780/download_10_plcptp.png",
      },
      {
        name: "Mocha",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975697/download_7_mhoh2p.png",
      },
      {
        name: "Jest",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975780/download_8_retqt9.png",
      },
      {
        name: "Jasmine",
        image:
          "https://res.cloudinary.com/dvshmozwc/image/upload/v1734975780/download_9_u8puqh.png",
      },
      {
        name: "CodeceptJS",
        image:
          "https://codecept.io/logo.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Bitbucket",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/44_Bitbucket_logo_logos-1024.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://cdn.freebiesupply.com/logos/large/2x/adobe-xd-logo-png-transparent.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Jira",
        image:
          "https://cdn.iconscout.com/icon/free/png-512/free-jira-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-brand-vol-1-pack-logos-icons-3030001.png?f=webp&w=512",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dvshmozwc/image/upload/v1734957431/ltim1_penqgq.jpg",
    role: "Senior Software Engineer",
    company: "LTIMindtree",
    date: "Nov 2019 - Jan 2024",
    desc: "Expertise in engagging with Microsoft Cliet and working in developing and automating different Applications. Designed end-to-end test suites for web applications using Playwright JavaScript, Typescript. identifying critical bugs before production. Increased Test coverage by 40% and Test efficency by 30 % and  Integrated automated tests into Azure DevOps CI/CD pipelines,resulting in earlier issue detection and reduced deployment time by 40%",
    skills: [
      "Playwright",
      "Azure CI/CD",
      "NodeJs",
      "Git",
      "HTML",
      "CSS",
      "JavaScript",
      "Typescript",
    ],
  },
  {
    id: 1,
    img: "https://companieslogo.com/img/orig/WKL.AS-4fb51e0c.png?t=1720244494",
    role: "Senior Product Software Engineer",
    company: "Wolters Kluwer",
    date: "Jan 2024 - Present",
    desc: "Development and enhancement of high-impact products, contributing to the design, architecture, and implementation of scalable software solutions. Development of dynamic, responsive, and user-centric applications.",
    skills: [
      "Playwright",
      "CodeceptJS",
      "Cucumber",
      "Jest",
      "ReactJS",
      "ExpressJS",
      "NodeJs",
      "Bamboo",
      "Git",
      "HTML",
      "CSS",
      "JavaScript",
      "Typescript",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dvshmozwc/image/upload/v1734959434/download_2_f9sd98.png",
    school: "Savitribai Phule Pune University",
    date: "May 2015 - July 2019",
    grade: "7.6 CGPA",
    desc: "I completed my Bachelor's degree in Information Technology from Pune University. I have secured First Class with Distinction with CGPA of 7.46. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Machine Learning, Cloud Computing, Object Oriented Programing and Computer Networks",
    degree: "Bachelor of Engineering , B.E - Information Technology",
  },
];

export const training = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dvshmozwc/image/upload/v1735018830/download_4_bpbbnd.jpg",
    role: "Full Stack Developer",
    company: "Coding Ninjas",
    date: "May 2023 - Present",
    desc: "Aspiring Full Stack Developer with hands-on experience in building responsive web applications and RESTful APIs. Proficient in React.js, Node.js, Express.js, JavaScript, HTML, CSS, and Java, with a strong foundation in Data Structures and Algorithms (DSA). Skilled in creating scalable and efficient solutions, with a passion for problem-solving and continuous learning. Completed an intensive Full Stack Development Bootcamp at Coding Ninjas, gaining expertise in modern web development technologies and best practices.",
    skills: [
      "ReactJS",
      "ExpressJS",
      "NodeJs",
      "MongoDB",
      "HTML",
      "CSS",
      "JavaScript",
      "Java",
      "Data Structures",
      "Generative AI"
    ],
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dvshmozwc/image/upload/v1735020324/download_13_uv6c5r.png",
    role: "Software development in Test - SDET",
    company: "Qspiders",
    date: "Jul 2019 - Nov 2019",
    desc: "Completed SDET training at QSpiders, gaining expertise in Java, SQL, and automation testing using tools like Selenium, along with proficiency in manual testing. Skilled in test case creation, defect tracking, and applying testing methodologies to ensure software quality, with a strong focus on problem-solving and teamwork.",
    skills: [
      "SQL",
      "HTML",
      "CSS",
      "JavaScript",
      "Java",
      "Data Structures",
      "Manual Testing",
    ],
  },
];


export const projects = [
  {
    id: 1,
    title: "Interview Cracker App",
    date: "Nov 2025 - Dec 2025",
    description:
      "Interview Cracker is an intelligent interview preparation platform designed to help developers ace their technical interviews. Featuring a curated library of 300+ interview questions, AI-powered feedback, live interview simulations, and personalized question generation, Interview Cracker provides everything candidates need to master interviews and unlock career opportunities.",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1767079203/ICA_cimf17.png",
    tags: [
      "React JS",
      "Vite",
      "Tailwind CSS",
      "Node Js",
      "OLLAMA",
      "OpenAI",
      "Express JS",
      "MongoDB",
      "cloude google",
      "JWT",
      "render",
      "netlify"
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/ICA",
    webapp: "https://interview-cracker-app.netlify.app/",
  },
  {
    id: 2,
    title: "Podmint",
    date: "Jul 2025 - Sep 2025",
    description:
      "Podmint is a AI cutting-edge podcast platform that allows users to create, share, and discover podcasts with ease. Built with React JS, Podmint offers a sleek and intuitive interface for both podcast creators and listeners, making it the go-to destination for all things podcasting.",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1754750572/PODMINT-UI_jifqqb.png",
    tags: [
      "React JS",
      "Vite",
      "Tailwind CSS",
      "Node Js",
      "OLLAMA",
      "OpenAI",
      "Express JS",
      "MongoDB",
      "google tts",
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/podmint",
    webapp: "https://github.com/Surajchowdhury12/",
  },
  {
    id: 3,
    title: " Connectly",
    date: "Jan 2025 - Apr 2025",
    description:
      "Connectly is a modern social networking app built with React JS, designed to bring people together in a seamless and engaging way. Whether you're connecting with friends, sharing life updates, or discovering new communities, Connectly offers a dynamic, user-friendly experience that feels like home.",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1743919972/connectly_gbkjz6.png",
    tags: [
      "CI/CD",
      "Express JS",
      "JavaScript",
      "Node Js",
      "Git Actions",
      "React JS",
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/Connectly_SocialMediaApp",
    webapp: "https://github.com/Surajchowdhury12/",
  },
  {
    id: 4,
    title: " Food Delivery App - MERN",
    date: "Nov 2024 - Dec 2024",
    description:
      "Food Delivery app that stores all dishes and user can sign in and signup create account and they can order food , save to cart, and choose favorite food they can track ordered food and much more ",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1735666467/Screenshot_2024-12-31_230200_b2fgza.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Rest API",
      "JWT",
      "bycrypt"
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/FoodDelivery-MERN",
    webapp: "https://github.com/Surajchowdhury12/FoodDelivery-MERN",
  },
  {
    id: 5,
    title: "Chat App- Using Socket IO",
    date: "Mar 2024 - Apr 2024",
    description:
      "A asynchromus chat application like somehat Whatsapp apis work to Connect with Users and chat in realtime , gives notification user when joined and left the chat. Added a notif ringtone for new messages pop ups",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1734960531/1_lzsFVtTfsGuJwB70eAWFlw_yn6ndp.png",
    tags: [
      "HTML",
      "CSS",
      "Node Js",
      "Express Js",
      "JavaScript",
      "Socket IO",
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/SCChatAppUsingSocketIO",
    webapp: "https://github.com/Surajchowdhury12/SCChatAppUsingSocketIO",
  },
  {
    id: 6,
    title: " FoodNama ",
    date: "Jun 2024 - Jul 2024",
    description:
      "FoodNama an app which consist of list of food options to be ordered by a customer , A customer can search and place an order for his favorite food which later can be added o his order list and also added a favorite list to reserve the food to order next time ",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1734960880/Screenshot_2024-12-23_190226_tddd2y.png",
    tags: [
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Rest API",
    ],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/Foodnaama",
    webapp: "https://surajchowdhury12.github.io/Foodnaama/",
  },
  {
    id: 7,
    title: "IMDB Clone",
    date: "July 2024 -  Aug 2024",
    description:
      "Developed a IMDB Clone using HTML, CSS, JavaScript and Tailwind CSS for designs. The application uses OMDB API to fetch the movie details and display it to the user based on the user inputs.",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1734972937/Screenshot_2024-12-23_222334_j91liu.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "https://github.com/Surajchowdhury12/IMDBproject27dec2023",
    webapp: "https://surajchowdhury12.github.io/IMDBproject27dec2023/",
  },
  {
    id: 8,
    title: " LambdaTest-Playwright",
    date: "Aug 2024 - Sep 2024",
    description:
      "LambdaTest Automation consisting a framework which is build upon a Javascript and created a Test suits in Playweright and used docker GitLab and Git Actions to utilize the test cases and run it in different environments through containers caller docker container and have integrated to CI CD pipelines to remotely work and deploy the fixtures and newly automated Test scripts ",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1734976837/download_2_mtunoq.jpg",
    tags: [
      "CI/CD",
      "GitLab",
      "Docker",
      "Node Js",
      "Git Actions",
      "Playwright",
    ],
    category: "automation",
    github: "https://github.com/Surajchowdhury12/LamdaTest-Playwright",
    webapp: "https://github.com/Surajchowdhury12/LamdaTest-Playwright",
  },
  {
    id: 9,
    title: " Cucumber BDD Framework",
    date: "Sep 2024 - Oct 2024",
    description:
      "Cucumber is an optimized framework used to write Test scripts and mainatain test framework in Gherkin language with the help of feature file its easy and sustainable code which can be understood by a non programmer utilized it to create test cases in playwright ",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1734977186/download_3_pxupco.jpg",
    tags: [
      "CI/CD",
      "Github",
      "Cucumber",
      "Node Js",
      "Git Actions",
      "Playwright",
    ],
    category: "frameworks",
    github: "https://github.com/Surajchowdhury12/LamdaTest-Playwright",
    webapp: "https://github.com/Surajchowdhury12/LamdaTest-Playwright",
  },
  {
    id: 10,
    title: " Mocha Framework",
    date: "Oct 2024 - Nov 2024",
    description:
      "Utilized mocha framework with chai libraries to create a framework which we used to mainatain the Test cases and performed various actions to validate authentictiy and correctness of the page used to handle the complex data sets ",
    image:
      "https://res.cloudinary.com/dvshmozwc/image/upload/v1735015821/download_12_laonpg.png",
    tags: [
      "CI/CD",
      "Github",
      "Mocha",
      "Node Js",
      "Git Actions",
      "Chai",
    ],
    category: "frameworks",
    github: "https://github.com/Surajchowdhury12/",
    webapp: "https://github.com/Surajchowdhury12/",
  },

];


